import { render, staticRenderFns } from "./EditorWord.vue?vue&type=template&id=44be5bb0&scoped=true"
import script from "./EditorWord.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorWord.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditorWord.vue?vue&type=style&index=0&id=44be5bb0&prod&scoped=true&vars=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44be5bb0",
  null
  
)

export default component.exports